/**
 *
 * LoginSuccessfullTag
 *
 */

import React, { memo } from 'react';
import styled from 'styled-components';

import { COLORS } from 'theme';
import Tag from '..';

const StyledTag = styled(Tag)`
  &.MuiChip-root {
    color: ${COLORS.black30};
    background: ${COLORS.black04};
    border-color: ${COLORS.black30};
    border-radius: ${({ theme }) => theme.borderRadius.secondary};

    &&& .MuiChip-icon path {
      fill: ${COLORS.black30};
    }
  }
`;

function LoginSuccessfulTag(props) {
  return <StyledTag label="Successful" {...props} />;
}

export default memo(LoginSuccessfulTag);
